import {Component, EventEmitter, Output} from '@angular/core';

import {map, shareReplay, switchMap} from 'rxjs/operators';
import PermissionLevel from 'src/app/permission/enums/permissionLevel.enum';
import {RoutingService} from 'src/app/services/routing.service';
import {UserService} from 'src/app/services/shared/user.service';
import {ImpersonateAsUserDetails} from '../../../models/ImpersonateAsUserDetails.model';
import {ImpersonationService} from '../../../services/shared/impersonation.service';
import {TerraUtils} from '../../TerraUtils';
import {NoPermissionAction} from '../../directives/check-permissions.directive';
import {InvestingEntityShareService} from '../../../lp/investing-entity-share/services/investing-entity-share.service';
import {EMPTY} from 'rxjs';

@Component({
  selector: 'terra-account-actions',
  templateUrl: './account-actions.component.html',
  styleUrls: ['./account-actions.component.scss'],
})
export class AccountActionsComponent {
  @Output() onAction: EventEmitter<void> = new EventEmitter();

  constructor(
    public routingService: RoutingService,
    private userService: UserService,
    private impersonationService: ImpersonationService,
    private readonly investingEntityShareService: InvestingEntityShareService
  ) {
  }

  paths = TerraUtils.consts.paths;

  accountDetails$ = this.userService.accountDetails$.pipe(
    map((account) => {
      if (this.isViewingAsInvestor) {
        const user = this.impersonateAsDetails;
        account = {
          ...account,
          firstName: user.firstName,
          lastName: user.lastName,
          userName: user.username,
        };
      }

      return account;
    }),
    shareReplay(1)
  );

  isAgent$ = this.accountDetails$.pipe(
    map((account) => !!account.isAgent),
    shareReplay(1)
  );

  myAccountUrl$ = this.accountDetails$.pipe(
    map((accountDetails) =>
      accountDetails.isAgent
        ? this.routingService.myAccountPageGp
        : this.routingService.myAccountPageLp
    ),
    shareReplay(1)
  );

  availableInvestingEntities$ = this.accountDetails$.pipe(
    switchMap(accountDetails =>
      accountDetails.isAgent ? EMPTY : this.investingEntityShareService.investingEntities$
    ),
    shareReplay(1)
  );

  isClientHasActiveOrders = true;
  PermissionLevel = PermissionLevel;
  NoPermissionAction = NoPermissionAction;

  get isViewingAsInvestor(): boolean {
    return this.impersonationService.isViewingAsInvestor;
  }

  private get impersonateAsDetails(): ImpersonateAsUserDetails {
    return this.impersonationService.impersonateAsDetails;
  }

  share() {
    this.onAction.emit();
  }
}
